const messages = {
  'customerTemplate.baseModel': 'Modelo de base',
  'customerTemplate.noModel': 'Sem modelo',
  'customerTemplate.importAction': 'Importacao de modelo',
  'customerTemplate.importDisabled': 'Cliente sem modelo de importacao',
  'customerTemplate.importTitle': 'Importacao de modelo do cliente',
  'customerTemplate.inviteAction': 'Enviar convite',
  'customerTemplate.inviteTitle': 'Enviar convite de cliente',
  'customerTemplate.inviteName': 'Nome',
  'customerTemplate.inviteEmail': 'E-mail',
  'customerTemplate.inviteSuccess': 'Convite enviado com sucesso.',
  'customerTemplate.inviteError': 'Nao foi possivel enviar o convite.',
  'customerTemplate.inviteSubmit': 'Enviar',
  'customerTemplate.inviteSubmitting': 'Enviando...',
  'customerTemplate.confirmTemplateLabel': 'Confirme o modelo que sera vinculado a este convite:',
  'customerTemplate.reviewTemplate': 'Revisar modelo',
  'customerTemplate.confirmInviteSubmit': 'Confirmar e enviar',
  'customerTemplate.cancel': 'Cancelar',
  'customerTemplate.loading': 'Carregando importacao...',
  'customerTemplate.empty': 'Nenhuma importacao de modelo registrada para este cliente.',
  'customerTemplate.loadError': 'Nao foi possivel carregar a importacao do modelo.',
  'customerTemplate.reprocessError': 'Nao foi possivel reprocessar a importacao do modelo.',
  'customerTemplate.reprocessSuccess': 'Reprocessamento completo da base agendado.',
  'customerTemplate.reprocess': 'Reprocessar base completa',
  'customerTemplate.reprocessing': 'Reprocessando...',
  'customerTemplate.tenantMigration': 'Estrutura da base',
  'customerTemplate.tenantMigrationStatus': 'Status da migration',
  'customerTemplate.tenantMigrationStartedAt': 'Inicio da migration',
  'customerTemplate.tenantMigrationFinishedAt': 'Fim da migration',
  'customerTemplate.migrateTenant': 'Atualizar estrutura da base',
  'customerTemplate.migratingTenant': 'Atualizando estrutura...',
  'customerTemplate.migrateTenantSuccess': 'Atualização da estrutura da base agendada.',
  'customerTemplate.migrateTenantError': 'Nao foi possivel atualizar a estrutura da base.',
  'customerTemplate.auditTenant': '1. Validar estrutura',
  'customerTemplate.auditingTenant': 'Validando estrutura...',
  'customerTemplate.auditTenantSuccess': 'Validação da estrutura agendada.',
  'customerTemplate.reconcileTenant': '2. Registrar itens validados',
  'customerTemplate.reconcilingTenant': 'Registrando itens...',
  'customerTemplate.auditTitle': 'Fluxo de atualização da estrutura',
  'customerTemplate.auditHint': 'Primeiro valide. Registre somente itens já existentes e validados. Depois aplique as migrations pendentes.',
  'customerTemplate.refreshModel': 'Atualizar modulos disponiveis',
  'customerTemplate.refreshingModel': 'Atualizando modulos...',
  'customerTemplate.refreshModelSuccess': 'Modulos disponiveis atualizados. Selecione o modulo para reprocessar.',
  'customerTemplate.refreshModelError': 'Nao foi possivel atualizar os modulos disponiveis.',
  'customerTemplate.reprocessModule': 'Reprocessar modulo',
  'customerTemplate.reprocessModuleSuccess': 'Reprocessamento do modulo agendado.',
  'customerTemplate.reprocessModuleError': 'Nao foi possivel reprocessar o modulo.',
  'customerTemplate.selectModule': 'Selecione um modulo',
  'customerTemplate.refresh': 'Atualizar',
  'customerTemplate.unlock': 'Destravar para reprocessar',
  'customerTemplate.unlocking': 'Destravando...',
  'customerTemplate.unlockSuccess': 'Importacao destravada. Reprocessamento liberado.',
  'customerTemplate.unlockError': 'Nao foi possivel destravar a importacao do modelo.',
  'customerTemplate.staleRunning': 'Importacao sem atualizacao recente. O cliente segue bloqueado ate reprocessar com sucesso.',
  'customerTemplate.runningHint': 'Importacao em execucao. Use Atualizar para acompanhar o progresso.',
  'customerTemplate.template': 'Modelo',
  'customerTemplate.status': 'Status',
  'customerTemplate.sourceCustomer': 'Cliente origem',
  'customerTemplate.targetCustomer': 'Cliente destino',
  'customerTemplate.startedAt': 'Inicio',
  'customerTemplate.finishedAt': 'Fim',
  'customerTemplate.updatedAt': 'Ultima atualizacao',
  'customerTemplate.error': 'Erro',
  'customerTemplate.modules': 'Modulos',
  'customerTemplate.missingFiles': 'Arquivos nao encontrados',
  'customerTemplate.missingFilesEmpty': 'Nenhum arquivo ausente registrado.',
  'customerTemplate.attachmentId': 'Anexo origem',
  'customerTemplate.versionId': 'Versao origem',
  'customerTemplate.reason': 'Motivo',
  'customerTemplate.path': 'Caminho',
  'customerTemplate.idMap': 'Mapa de IDs',
  'customerTemplate.idMapAuditHint': 'Resumo por modulo e tipo importado',
  'customerTemplate.idMapGroupCount': '{count} importado(s)',
  'customerTemplate.idMapName': 'Nome',
  'customerTemplate.idMapSourceId': 'ID origem',
  'customerTemplate.idMapTargetId': 'ID destino',
  'customerTemplate.idMapRaw': 'Ver JSON tecnico',
  'customerTemplate.comparison': 'Resumo Cliente x Modelo',
  'customerTemplate.comparisonHint': 'Compara somente os registros vinculados a esta importacao. Dados proprios do cliente nao entram no resultado.',
  'customerTemplate.generateComparison': 'Gerar comparativo',
  'customerTemplate.refreshComparison': 'Atualizar comparativo',
  'customerTemplate.generatingComparison': 'Gerando comparativo...',
  'customerTemplate.comparisonError': 'Nao foi possivel gerar o comparativo da importacao.',
  'customerTemplate.comparisonGeneratedAt': 'Gerado em {date}',
  'customerTemplate.comparisonModel': 'Modelo',
  'customerTemplate.comparisonTarget': 'Cliente confirmado',
  'customerTemplate.comparisonAttention': 'Pendencias',
  'customerTemplate.comparisonStatus.completed': 'Concluido',
  'customerTemplate.comparisonStatus.attention': 'Atencao',
  'customerTemplate.comparisonStatus.unavailable': 'Indisponivel',
  'customerTemplate.reason.storage_file_missing_or_copy_failed': 'Arquivo ausente ou falha ao copiar',
  'customerTemplate.status.pending': 'Pendente',
  'customerTemplate.status.running': 'Em execucao',
  'customerTemplate.status.completed': 'Concluido',
  'customerTemplate.status.failed': 'Falhou',
  'customerTemplate.status.partially_completed': 'Parcialmente concluido',
  'customerTemplate.status.skipped': 'Ignorado',
  'customerTemplate.module.system': 'Sistema',
  'customerTemplate.module.documents': 'Documentos',
  'customerTemplate.module.norm': 'Normas',
  'customerTemplate.module.operational_panel': 'Painel Operacional',
  'customerTemplate.module.ciq': 'CIQ',
  'customerTemplate.module.indicator': 'Indicadores',
  'customerTemplate.stage.folders': 'pastas',
  'customerTemplate.stage.documents': 'documentos',
  'customerTemplate.stage.versions': 'versoes',
  'customerTemplate.stage.attachments': 'anexos',
  'customerTemplate.stage.start': 'inicio',
  'customerTemplate.stage.permission_groups': 'grupos de permissao',
  'customerTemplate.stage.teams': 'equipes',
  'customerTemplate.stage.permission_group_permissions': 'permissoes dos grupos',
  'customerTemplate.stage.team_permission_groups': 'grupos por equipe',
  'customerTemplate.stage.admin_teams': 'vinculo do admin com equipes',
  'customerTemplate.stage.admin_permission_groups': 'vinculo do admin com grupos',
  'customerTemplate.stage.norms': 'normas',
  'customerTemplate.stage.requisites': 'requisitos',
  'customerTemplate.stage.requisite_sections': 'secoes de requisitos',
  'customerTemplate.stage.item_checklists': 'checklists',
  'customerTemplate.stage.document_evidences': 'evidencias de documentos',
  'customerTemplate.stage.fields': 'campos',
  'customerTemplate.stage.field_options': 'opcoes de campos',
  'customerTemplate.stage.field_qualitative_classifications': 'classificacoes qualitativas',
  'customerTemplate.stage.panels': 'paineis',
  'customerTemplate.stage.boards': 'quadros',
  'customerTemplate.stage.board_requisites': 'vinculos com requisitos',
  'customerTemplate.stage.blocks': 'blocos',
  'customerTemplate.stage.model_boards': 'quadros modelo',
  'customerTemplate.stage.model_board_fields': 'campos do quadro modelo',
  'customerTemplate.stage.activities': 'atividades',
  'customerTemplate.stage.field_values': 'valores dos campos',
  'customerTemplate.stage.visible_fields': 'campos visiveis',
  'customerTemplate.stage.hidden_fields': 'campos ocultos',
  'customerTemplate.stage.field_relations': 'relacoes de campos',
  'customerTemplate.stage.sectors': 'setores',
  'customerTemplate.stage.result_options': 'opcoes de resultado',
  'customerTemplate.stage.westgard_rules': 'regras Westgard',
  'customerTemplate.stage.causes': 'causas',
  'customerTemplate.stage.analytes': 'analitos',
  'customerTemplate.stage.analyte_result_options': 'opcoes por analito',
  'customerTemplate.stage.controls': 'controles',
  'customerTemplate.stage.control_analytes': 'analitos por controle',
  'customerTemplate.stage.control_analyte_result_options': 'opcoes por controle/analito',
  'customerTemplate.stage.equipments': 'equipamentos',
  'customerTemplate.stage.equipment_analytes': 'analitos por equipamento',
  'customerTemplate.stage.equipment_analyte_westgard_rules': 'Westgard por equipamento/analito',
  'customerTemplate.stage.tabs': 'abas',
  'customerTemplate.stage.tab_team_permissions': 'permissoes por equipe',
  'customerTemplate.stage.indicators': 'indicadores',
  'customerTemplate.stage.indicator_blocks': 'blocos dos indicadores',
  'customerTemplate.stage.marks': 'metas',
  'customerTemplate.statusDetail.count': '({stage}: {processed}/{total})',
  'customerTemplate.statusDetail.stage': '({stage})',
  'customerTemplate.statusDetail.error': 'Erro: {message}',
};

/**
 * Retorna textos do fluxo de modelos sem espalhar frases nos componentes.
 */
export const tCustomerTemplate = (cKey, oParams = {}) => {
  const cMessage = messages[cKey] || cKey;

  return Object.keys(oParams).reduce(
    (cText, cParamKey) => cText.replace(`{${cParamKey}}`, oParams[cParamKey]),
    cMessage
  );
};

/**
 * Traduz status tecnicos retornados pelo backend para exibicao no admin.
 */
export const tCustomerTemplateStatus = cStatus => (
  tCustomerTemplate(`customerTemplate.status.${cStatus}`)
);

/**
 * Traduz etapas internas da importacao de cada modulo.
 */
export const tCustomerTemplateStage = cStage => (
  tCustomerTemplate(`customerTemplate.stage.${cStage}`)
);

/**
 * Traduz motivos operacionais registrados no mapa de importacao.
 */
export const tCustomerTemplateReason = cReason => (
  tCustomerTemplate(`customerTemplate.reason.${cReason}`)
);

/**
 * Traduz nomes tecnicos de modulos retornados no acompanhamento da importacao.
 */
export const tCustomerTemplateModule = cModule => (
  tCustomerTemplate(`customerTemplate.module.${cModule}`)
);
